import { Theme } from '@mui/material';

export const menuStyles = (theme: Theme) => ({
  MuiMenu: {
    styleOverrides: {
      paper: {
        backgroundColor: theme.palette.mode === 'light' ? '#fcfcfc' : '#1d1d1d',
      },
      list: {
        padding: 4,
        backgroundColor: theme.palette.mode === 'light' ? '#fcfcfc' : '#1d1d1d',

        '& .MuiMenuItem-root': {
          color: theme.palette.mode === 'light' ? '#525252' : '#d4d4d4',
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  },
});
